
import { FleetNavigationModule } from "@app/main/modules/fleet/fleet.navigation";
import { AccountFeatures } from "@enums/account/AccountFeature";
import { AuthorizationService } from "@services/authorization.service";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { CsvImporterController } from "../csvImporter/csvImporter.component";
import { GeofenceImporterController } from "../csvImporter/geofenceImporter/geofenceImporter.component";
import { PlanningController } from "./planning.controller";

export class PlanningConfig {

    static $inject = ["$stateProvider"];

    constructor($stateProvider: StateProvider) {

        $stateProvider.state(FleetNavigationModule.Planning, {
            url: "/planning/:page/:argument1",
            views: {
                "content@app": {
                    template: require("./planning.html"),
                    controller: "planningController as $ctrl"
                }
            },
            params: {
                page: { squash: true, value: null, dynamic: true },
                argument1: { squash: true, value: null, dynamic: true },
                startingPosition: { squash: true, value: null, dynamic: true },
                startingAddress: { squash: true, value: null, dynamic: true }
            },
            data: { translation: "Common.Planning" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([], [AccountFeatures.TMS], [], true)]
            }
        });
    }
}

angular
    .module("app.components.planning", [
        "ui.router",
        "app.components.util.api"
    ])
    .config(PlanningConfig)
    .controller("planningController", PlanningController)
    .controller("geofenceImporterController", GeofenceImporterController)
    .controller("csvImporterController", CsvImporterController);
